const currency = (value) => {
    let toFormat = 0
    if (value) {
        toFormat = +value
    }
    return toFormat.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
}

module.exports = currency
module.exports.default = currency